import { Route, Routes } from 'react-router-dom';
import './App.css';
import Signup from './components/signup/Signup';
import PrivacyPolicy from './components/privacypolicy/PrivacyPolicy';
import Support from './components/support/Support';
import Delete from './components/Delete/Delete';

function App() {
  return (
    <Routes>
      <Route path="/signup" element={<Signup />} />
      <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      <Route path="/support" element={<Support />} />
      <Route path="/steps-account-delete" element={<Delete />} />
    </Routes>
  );
}

export default App;
